import { render } from "./TableOfContents.vue?vue&type=template&id=6ede2189&scoped=true"
import script from "./TableOfContents.vue?vue&type=script&lang=js"
export * from "./TableOfContents.vue?vue&type=script&lang=js"

import "./TableOfContents.vue?vue&type=style&index=0&id=6ede2189&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ede2189"

export default script